import { render, staticRenderFns } from "./LanguagesCounts.vue?vue&type=template&id=7a51eea1&scoped=true&"
import script from "./LanguagesCounts.vue?vue&type=script&lang=js&"
export * from "./LanguagesCounts.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesCounts.vue?vue&type=style&index=0&id=7a51eea1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a51eea1",
  null
  
)

export default component.exports